import { all } from 'redux-saga/effects'
import watchGetGraphUrine, { watchGetGraphUrinePublic } from './graph-urine'


export default function* sagas() {
    yield all([
        watchGetGraphUrine(),
        watchGetGraphUrinePublic()
    ])
}
